import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'phoneFormat'
})
export class PhoneFormat implements PipeTransform {

	transform(phone: any, args?: any): any {
		return phone.trim().replace(/[^\d]/g,'');
	}

}
